export default "__VITE_ASSET__C1haKFT0__"